import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { cn } from '@/lib/utils'

const LOGO_SRC = '/images/stayvora-logo.png'

export const LogoBadge: FC<{ size?: number, className?: string, priority?: boolean }> = ({ size = 48, className, priority }): ReactNode => {
    return (
        <Image
            src={LOGO_SRC}
            alt='STAYVORA Booking'
            width={size}
            height={size}
            priority={priority}
            sizes={`${size}px`}
            className={cn('rounded-full bg-white shadow-[0_0_0_1px_rgba(212,175,90,0.35),0_10px_30px_-12px_rgba(212,175,90,0.6)]', className)}
        />
    )
}

export const Wordmark: FC<{ className?: string, subline?: boolean }> = ({ className, subline = true }): ReactNode => {
    return (
        <span className={cn('inline-flex flex-col leading-none', className)} dir='ltr'>
            <span className='text-[1.35em] font-extrabold tracking-[0.12em]'>
                <span className='text-foreground'>STAY</span>
                <span className='text-[#e0362e]'>V</span>
                <span className='text-foreground'>OR</span>
                <span className='text-gold'>A</span>
            </span>

            {subline && (
                <span className='mt-1 text-[0.55em] font-semibold tracking-[0.5em] text-gold/90'>
                    BOOKING
                </span>
            )}
        </span>
    )
}
